import React from 'react';
import cn from 'classnames';
import './ChatUserStatus.scss';

type ChatUserStatusProps = {
    className?: string;
};

export const ChatUserStatus = ({ className }:ChatUserStatusProps) => <div className={cn('chat-user-status', className)}/>